// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();

// Theme toggle (light/dark), persisted to localStorage under 'tonal-theme'
function initThemeToggle() {
  var btn = document.querySelector('.theme-toggle');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var cur = document.documentElement.dataset.theme;
    var prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    var next = (cur === 'dark' || (!cur && prefersDark)) ? 'light' : 'dark';
    document.documentElement.dataset.theme = next;
    try { localStorage.setItem('tonal-theme', next); } catch (e) {}
  });
}
document.addEventListener('DOMContentLoaded', initThemeToggle);

// Sticky Contents rail + mobile <details> collapse, populated from post-content h2[id]
function initToc() {
  var content = document.querySelector('.post-content');
  if (!content) return;
  var heads = Array.prototype.slice.call(content.querySelectorAll('h2[id]'));
  var rail = document.querySelector('.toc-rail');
  var collapse = document.querySelector('.toc-collapse');
  if (!heads.length || !rail) return; // no H2s -> both stay hidden
  [rail, collapse].forEach(function (host) {
    if (!host) return;
    var box = host.querySelector('.toc-links');
    heads.forEach(function (h) {
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      box.appendChild(a);
    });
    host.hidden = false;
  });
  var links = rail.querySelectorAll('a');
  var collapseLinks = collapse ? collapse.querySelectorAll('a') : [];
  var byId = {};
  links.forEach(function (a) { byId[a.getAttribute('href').slice(1)] = a; });
  var collapseById = {};
  collapseLinks.forEach(function (a) { collapseById[a.getAttribute('href').slice(1)] = a; });
  function activate(a) {
    links.forEach(function (x) { x.removeAttribute('aria-current'); });
    collapseLinks.forEach(function (x) { x.removeAttribute('aria-current'); });
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (byId[id]) byId[id].setAttribute('aria-current', 'true');
    if (collapseById[id]) collapseById[id].setAttribute('aria-current', 'true');
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) activate(byId[e.target.id]);
    });
  }, { rootMargin: '-20% 0px -70% 0px' });
  heads.forEach(function (h) { obs.observe(h); });
  // Bottom-of-page fallback: a short final section may never cross the observer band.
  // rAF-gated so the scrollHeight read (forces sync layout) happens at most once per frame.
  var tocScrollTicking = false;
  function checkBottomFallback() {
    tocScrollTicking = false;
    if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
      activate(byId[heads[heads.length - 1].id]);
    }
  }
  window.addEventListener('scroll', function () {
    if (tocScrollTicking) return;
    tocScrollTicking = true;
    window.requestAnimationFrame(checkBottomFallback);
  }, { passive: true });
}
document.addEventListener('DOMContentLoaded', initToc);

// Bounded tables: wrap once, then observe wrappers only (never mutate observed DOM in the RO callback)
function initTables() {
  var content = document.querySelector('.post-content');
  if (!content) return;
  /* Phase 1: wrap every table exactly once, before any observation. */
  var wraps = [];
  content.querySelectorAll('table').forEach(function (t) {
    var wrap = document.createElement('div');
    wrap.className = 'table-wrap';
    t.parentNode.insertBefore(wrap, t);
    wrap.appendChild(t);
    wraps.push(wrap);
  });
  if (!wraps.length) return;
  /* Phase 2: measurement only — setting data-wide toggles styling, never layout size. */
  function measure(wrap) {
    var t = wrap.querySelector('table');
    wrap.dataset.wide = (t.scrollWidth > wrap.clientWidth + 1) ? 'true' : 'false';
  }
  function measureAll() { wraps.forEach(measure); }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(measureAll);
  } else { measureAll(); }
  var ro = new ResizeObserver(function (entries) {
    entries.forEach(function (e) { measure(e.target); });
  });
  wraps.forEach(function (w) { ro.observe(w); });
}
document.addEventListener('DOMContentLoaded', initTables);

// Tap-to-magnify content images, MOBILE ONLY (Konrad, phone reading: post images
// read small; tapping should expand to a full-screen overlay). Candidates are every
// <img> inside .post-content plus the feature image, EXCLUDING any image an <a> the
// author already added wraps (bookmark-card thumbnails etc.) — that link's own
// navigation must not be hijacked. Sponsor-banner logo, post-card thumbnails, and
// avatars are never candidates: none of them live inside .post-content or .feature-img.
function initZoom() {
  var content = document.querySelector('.post-content');
  var candidates = [];
  if (content) {
    Array.prototype.forEach.call(content.querySelectorAll('img'), function (img) {
      if (!img.closest('a')) candidates.push(img);
    });
  }
  var featureImg = document.querySelector('.feature-img img');
  if (featureImg && !featureImg.closest('a')) candidates.push(featureImg);
  if (!candidates.length) return;

  // 899.98px matches toc-rail.css's existing mobile/desktop split.
  var mq = window.matchMedia('(max-width: 899.98px)');
  var overlay = null, overlayImg = null, closeBtn = null, lastTrigger = null;

  // --- Pinch-zoom + pan state (overlayImg only; overlay background stays a plain
  // dismiss target). Scale 1 = fit (the pre-existing behavior); MAX_SCALE is the
  // magnify ceiling. transform is translate(px,px) scale(s): scale happens first
  // (around transform-origin: center), translate then shifts the already-scaled
  // element by that many CSS px in the overlay's own coordinate space, which is why
  // the pan-clamp math below can work in plain viewport pixels throughout. ---
  var MIN_SCALE = 1, MAX_SCALE = 4, DOUBLE_TAP_SCALE = 2.5;
  var TAP_MOVE_THRESHOLD = 10, DOUBLE_TAP_MS = 300, DOUBLE_TAP_DIST = 30;
  var scale = 1, panX = 0, panY = 0;
  var baseRect = null; // {cx, cy, w, h} of the untransformed (fit) layout box
  var pointers = {}; // pointerId -> {x, y}, live for the current gesture session
  var gesture = null; // null | 'pan' | 'pinch'
  var moved = false; // any movement past the tap threshold this session -> never a tap
  var tapStartX = 0, tapStartY = 0;
  var panStart = null; // {x, y, tx, ty}
  var pinchStart = null; // {dist, scale, anchorX, anchorY}
  var lastTapTime = 0, lastTapX = 0, lastTapY = 0;
  var resizeHandler = null;

  function pointerDistance(a, b) { return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2)); }
  function pointerMidpoint(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }

  function captureBaseRect() {
    var r = overlayImg.getBoundingClientRect();
    baseRect = { cx: r.left + r.width / 2, cy: r.top + r.height / 2, w: r.width, h: r.height };
  }

  function clampPan(s, tx, ty) {
    if (!baseRect) return { x: 0, y: 0 };
    var scaledW = baseRect.w * s, scaledH = baseRect.h * s;
    var vw = window.innerWidth, vh = window.innerHeight;
    var maxX = Math.max(0, (scaledW - vw) / 2);
    var maxY = Math.max(0, (scaledH - vh) / 2);
    return { x: Math.min(maxX, Math.max(-maxX, tx)), y: Math.min(maxY, Math.max(-maxY, ty)) };
  }

  function applyTransform() {
    overlayImg.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + scale + ')';
  }

  function resetZoom() {
    scale = MIN_SCALE; panX = 0; panY = 0;
    overlayImg.classList.remove('img-zoom-snap');
    applyTransform();
  }

  // Zoom to newScale while keeping the content point currently under
  // (anchorClientX, anchorClientY) fixed on screen — shared by double-tap zoom-in
  // and the reset-to-fit toggle (MIN_SCALE, any anchor -> panX/panY collapse to 0).
  function setScale(newScale, anchorClientX, anchorClientY) {
    if (!baseRect) return;
    newScale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, newScale));
    var localX = (anchorClientX - baseRect.cx - panX) / scale;
    var localY = (anchorClientY - baseRect.cy - panY) / scale;
    var newPanX = anchorClientX - baseRect.cx - newScale * localX;
    var newPanY = anchorClientY - baseRect.cy - newScale * localY;
    var clamped = clampPan(newScale, newPanX, newPanY);
    scale = newScale; panX = clamped.x; panY = clamped.y;
    overlayImg.classList.add('img-zoom-snap');
    applyTransform();
    setTimeout(function () { overlayImg.classList.remove('img-zoom-snap'); }, 260);
  }

  function beginPan(p) {
    panStart = { x: p.x, y: p.y, tx: panX, ty: panY };
    gesture = 'pan';
  }

  function updatePan(p) {
    if (!panStart) return;
    var dx = p.x - panStart.x, dy = p.y - panStart.y;
    var clamped = clampPan(scale, panStart.tx + dx, panStart.ty + dy);
    panX = clamped.x; panY = clamped.y;
    applyTransform();
  }

  function beginPinch() {
    var ids = Object.keys(pointers);
    if (ids.length < 2) return;
    var p1 = pointers[ids[0]], p2 = pointers[ids[1]];
    var dist = pointerDistance(p1, p2);
    var mid = pointerMidpoint(p1, p2);
    pinchStart = {
      dist: dist || 1,
      scale: scale,
      anchorX: (mid.x - baseRect.cx - panX) / scale,
      anchorY: (mid.y - baseRect.cy - panY) / scale
    };
    gesture = 'pinch';
    panStart = null;
  }

  function updatePinch() {
    var ids = Object.keys(pointers);
    if (ids.length < 2 || !pinchStart || !baseRect) return;
    var p1 = pointers[ids[0]], p2 = pointers[ids[1]];
    var dist = pointerDistance(p1, p2);
    var mid = pointerMidpoint(p1, p2);
    var newScale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, pinchStart.scale * (dist / pinchStart.dist)));
    var newPanX = mid.x - baseRect.cx - newScale * pinchStart.anchorX;
    var newPanY = mid.y - baseRect.cy - newScale * pinchStart.anchorY;
    var clamped = clampPan(newScale, newPanX, newPanY);
    scale = newScale; panX = clamped.x; panY = clamped.y;
    applyTransform();
  }

  function handleTap(x, y) {
    var now = Date.now();
    var dx = x - lastTapX, dy = y - lastTapY;
    var isDoubleTap = lastTapTime && (now - lastTapTime) < DOUBLE_TAP_MS && Math.sqrt(dx * dx + dy * dy) < DOUBLE_TAP_DIST;
    if (isDoubleTap) {
      lastTapTime = 0;
      if (scale > MIN_SCALE + 0.01) resetZoom();
      else setScale(DOUBLE_TAP_SCALE, x, y);
      return;
    }
    lastTapTime = now; lastTapX = x; lastTapY = y;
    if (scale > MIN_SCALE + 0.01) return; // clean tap while zoomed: no-op, never dismiss
    var capturedTime = now;
    setTimeout(function () {
      // Only close if no second tap claimed lastTapTime in the meantime, and the
      // overlay wasn't zoomed/moved again in the interim.
      if (lastTapTime === capturedTime && scale <= MIN_SCALE + 0.01) close();
    }, DOUBLE_TAP_MS + 30);
  }

  function onPointerDown(e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    try { overlayImg.setPointerCapture(e.pointerId); } catch (err) {}
    var isNewSession = Object.keys(pointers).length === 0;
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var count = Object.keys(pointers).length;
    if (isNewSession) {
      moved = false;
      tapStartX = e.clientX; tapStartY = e.clientY;
      gesture = null; panStart = null; pinchStart = null;
      if (scale > MIN_SCALE + 0.01) beginPan(pointers[e.pointerId]);
    } else if (count === 2) {
      moved = true; // two fingers down is always a gesture, never a tap
      beginPinch();
    }
  }

  function onPointerMove(e) {
    if (!(e.pointerId in pointers)) return;
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var count = Object.keys(pointers).length;
    if (count >= 2) {
      updatePinch();
      moved = true;
      e.preventDefault();
      return;
    }
    var dx = e.clientX - tapStartX, dy = e.clientY - tapStartY;
    if (!moved && Math.sqrt(dx * dx + dy * dy) > TAP_MOVE_THRESHOLD) moved = true;
    if (gesture === 'pan') {
      updatePan(pointers[e.pointerId]);
      e.preventDefault();
    } else if (moved && scale > MIN_SCALE + 0.01) {
      beginPan({ x: tapStartX, y: tapStartY });
      updatePan(pointers[e.pointerId]);
      e.preventDefault();
    }
  }

  function onPointerUp(e) {
    if (!(e.pointerId in pointers)) return;
    try { overlayImg.releasePointerCapture(e.pointerId); } catch (err) {}
    delete pointers[e.pointerId];
    var count = Object.keys(pointers).length;
    if (count === 1) {
      // Dropped from two fingers to one: keep tracking from here, no jump.
      var ids = Object.keys(pointers);
      pinchStart = null;
      if (scale > MIN_SCALE + 0.01) beginPan(pointers[ids[0]]);
      else gesture = null;
      return;
    }
    if (count !== 0) return;
    var wasGesture = moved || gesture === 'pinch';
    gesture = null; panStart = null; pinchStart = null;
    if (wasGesture) return;
    handleTap(e.clientX, e.clientY);
  }

  function onPointerCancel(e) {
    if (!(e.pointerId in pointers)) return;
    try { overlayImg.releasePointerCapture(e.pointerId); } catch (err) {}
    delete pointers[e.pointerId];
    if (Object.keys(pointers).length === 0) {
      gesture = null; panStart = null; pinchStart = null;
    }
  }

  function buildOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'img-zoom-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Expanded image');
    overlay.hidden = true;
    // Background (not the image) is always a plain dismiss target — it never
    // participates in pinch/pan, so it is never gated on tap-vs-gesture state.
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    overlayImg = document.createElement('img');
    overlayImg.className = 'img-zoom-overlay-img';
    overlayImg.addEventListener('pointerdown', onPointerDown);
    overlayImg.addEventListener('pointermove', onPointerMove);
    overlayImg.addEventListener('pointerup', onPointerUp);
    overlayImg.addEventListener('pointercancel', onPointerCancel);
    overlay.appendChild(overlayImg);

    closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'img-zoom-close';
    closeBtn.setAttribute('aria-label', 'Close expanded image');
    closeBtn.textContent = '×';
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      close();
    });
    overlay.appendChild(closeBtn);

    document.body.appendChild(overlay);
    return overlay;
  }

  function onKeydown(e) {
    var key = e.key || '';
    if (key === 'Escape' || e.keyCode === 27) {
      close();
      return;
    }
    // Overlay's only focusable descendant is the close button; pin focus there
    // rather than letting Tab escape into the (scroll-locked) page behind it.
    if (key === 'Tab' || e.keyCode === 9) {
      e.preventDefault();
      closeBtn.focus();
    }
  }

  function onOverlayResize() {
    // Geometry (viewport size, fit dimensions) can change under the open overlay
    // (orientation change, on-screen keyboard, browser chrome show/hide). Re-fit
    // rather than risk stale clamps against a size that no longer exists.
    resetZoom();
    captureBaseRect();
  }

  function open(img) {
    if (!mq.matches) return;
    buildOverlay();
    pointers = {}; gesture = null; panStart = null; pinchStart = null;
    moved = false; lastTapTime = 0; baseRect = null;
    resetZoom();
    overlayImg.src = img.currentSrc || img.src;
    overlayImg.alt = img.getAttribute('alt') || '';
    lastTrigger = img;
    overlay.hidden = false;
    document.body.classList.add('img-zoom-lock');
    document.addEventListener('keydown', onKeydown);
    resizeHandler = onOverlayResize;
    window.addEventListener('resize', resizeHandler);
    closeBtn.focus();
    if (overlayImg.complete && overlayImg.naturalWidth) captureBaseRect();
    else overlayImg.addEventListener('load', captureBaseRect, { once: true });
  }

  function close() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    overlayImg.src = '';
    overlayImg.classList.remove('img-zoom-snap');
    document.body.classList.remove('img-zoom-lock');
    document.removeEventListener('keydown', onKeydown);
    if (resizeHandler) { window.removeEventListener('resize', resizeHandler); resizeHandler = null; }
    pointers = {}; gesture = null; panStart = null; pinchStart = null;
    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  function onActivate(e) {
    if (!mq.matches) return;
    e.preventDefault();
    open(this);
  }

  function onKeyActivate(e) {
    if (!mq.matches) return;
    var key = e.key || '';
    if (key === 'Enter' || key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      open(this);
    }
  }

  // Zoomability is a mobile-only affordance: role/tabindex/cursor only apply while
  // the breakpoint gate is open, so desktop keyboard/tab order and screen-reader
  // hints are untouched. Re-checked on resize/orientation change, not just at load.
  function applyMode(isMobile) {
    candidates.forEach(function (img) {
      if (isMobile) {
        img.setAttribute('role', 'button');
        img.setAttribute('tabindex', '0');
        img.setAttribute('aria-label', 'Expand image');
        img.classList.add('img-zoomable');
      } else {
        img.removeAttribute('role');
        img.removeAttribute('tabindex');
        img.removeAttribute('aria-label');
        img.classList.remove('img-zoomable');
      }
    });
    if (!isMobile) close();
  }

  candidates.forEach(function (img) {
    img.addEventListener('click', onActivate);
    img.addEventListener('keydown', onKeyActivate);
  });

  applyMode(mq.matches);
  function onMqChange(e) { applyMode(e.matches); }
  // MediaQueryList.addEventListener has covered this browserslist ("defaults") since
  // Safari 14 (2020); the old addListener()/removeListener() pair is deprecated.
  mq.addEventListener('change', onMqChange);
}
document.addEventListener('DOMContentLoaded', initZoom);